import Vue from "vue"
import App from "./App.vue"
import "./utils/ls"

import router from "./router"
import store from "./store"
import vueSwiper from "vue-awesome-swiper"
import "swiper/swiper.min.css"
import "./vant"
import "./utils/setRem"
import "./styles/styles.less"
Vue.use(vueSwiper)
// import vconsole from "vconsole"
Vue.config.productionTip = false
// eslint-disable-next-line no-unused-vars
// var vConsole = new vconsole()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
